//const config = { apiUrl: "http://horizoncongreso.bounceme.net:8015/" }
//const config = { apiUrl: "http://192.168.0.210:8015/" }
//const config = { apiUrl: "http://localhost:53856/" }
const config = { apiUrl:'http://201.140.99.157:8015/'}
export default config

